<template>
  <div style="background-color: #f5f5f5; min-height: 100vh;">
    <van-nav-bar
        left-arrow
        title="开通提现授权"
        @click-left="$router.go(-1)"
        left-text=""/>
    <div class="auth-container">
      <div class="auth-icon-wrap">
        <van-image
            round
            src="/img/qiandai.png"
            width="80px"
            height="80px"
            error-icon="/img/nologin.png"/>
      </div>
      <div class="auth-title">开通收益提现授权</div>
      <div class="auth-desc">
        <p>开通后，您的佣金收益将自动转账到微信零钱，无需手动确认，资金实时到账。</p>
      </div>

      <!-- 已授权状态 -->
      <div v-if="transferAuthFlag === 1" class="auth-status-card auth-status-done">
        <van-icon name="checked" size="24" color="#07c160"/>
        <div class="auth-status-text">
          <div class="auth-status-title">已开通授权</div>
          <div class="auth-status-sub">收益提现将自动到账零钱</div>
        </div>
      </div>

      <!-- 未授权状态 -->
      <div v-else>
        <div class="auth-tips">
          <van-cell-group>
            <van-cell icon="shield-o" title="安全保障" label="由微信支付提供安全保障，资金直达零钱"/>
            <van-cell icon="gold-coin-o" title="自动到账" label="授权后提现无需确认，自动到账"/>
            <van-cell icon="clock-o" title="实时到账" label="免确认模式，最快实时到账"/>
          </van-cell-group>
        </div>
        <div style="margin: 30px 16px;">
          <van-button
              round
              block
              type="danger"
              :loading="loading"
              loading-text="正在跳转..."
              @click="openAuth">
            开通授权
          </van-button>
        </div>
        <div class="auth-notice">
          <van-icon name="info" size="14" color="#999"/>
          <span>点击后将跳转至微信授权页面，请完成授权即可</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Cell, CellGroup, Button, NavBar, Icon, Image as VanImage, Toast} from 'vant';
import {postAction} from '@/api/manage';

export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
  },
  data() {
    return {
      transferAuthFlag: 0,
      loading: false,
    };
  },
  mounted() {
    this.loadAuthStatus();
  },
  methods: {
    loadAuthStatus() {
      let that = this;
      postAction('/web/api/user/chekUserRebateFlag', {}).then(function (response) {
        that.transferAuthFlag = response.result.transferAuthFlag || 0;
      }).catch(function () {
        Toast('获取授权状态失败，请重试');
      });
    },
    openAuth() {
      let that = this;
      that.loading = true;
      postAction('/web/api/transfer/getAuthUrl', {}).then(function (response) {
        if (response.result && response.result.packageInfo) {
          // 调用微信JSAPI拉起免确认收款授权页面
          that.invokeWxAuthorization(response.result);
        } else if (response.code === 200 && response.message) {
          // 已授权或其他提示
          Toast(response.message);
          that.loadAuthStatus();
        } else {
          Toast('发起授权失败');
        }
      }).catch(function (e) {
        console.error(e);
        Toast('发起授权失败，请重试:' + e);
      }).finally(function () {
        that.loading = false;
      });
    },
    invokeWxAuthorization(authData) {
      let that = this;
      // 判断是否在微信内置浏览器中
      let ua = navigator.userAgent.toLowerCase();
      let isWechat = ua.indexOf('micromessenger') !== -1;

      if (!isWechat) {
        Toast('请在微信中打开此页面完成授权');
        return;
      }

      // 通过微信JSAPI拉起免确认收款授权页面
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', function () {
            that.callRequestMerchantTransfer(authData);
          }, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', function () {
            that.callRequestMerchantTransfer(authData);
          });
          document.attachEvent('onWeixinJSBridgeReady', function () {
            that.callRequestMerchantTransfer(authData);
          });
        }
      } else {
        that.callRequestMerchantTransfer(authData);
      }
    },
    callRequestMerchantTransfer(authData) {
      let that = this;
      WeixinJSBridge.invoke('requestMerchantTransfer', {
        mchId: authData.mchId,
        appId: authData.appId,
        package: authData.packageInfo,
      }, function (res) {
        if (res.err_msg === 'requestMerchantTransfer:ok') {
          // 用户在授权页面操作完成，不代表授权成功
          // 授权结果由后端回调更新，前端延迟刷新状态
          Toast('授权页面已关闭，正在查询授权结果...');
          setTimeout(function () {
            that.loadAuthStatus();
          }, 3000);
        } else if (res.err_msg === 'requestMerchantTransfer:cancel') {
          Toast('您已取消授权');
        } else {
          Toast('授权失败，请重试');
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.auth-container {
  padding: 20px 16px;
}

.auth-icon-wrap {
  text-align: center;
  margin-top: 20px;
}

.auth-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #323233;
  margin-top: 16px;
}

.auth-desc {
  text-align: center;
  color: #969799;
  font-size: 14px;
  margin: 12px 20px 24px;
  line-height: 1.6;

  p {
    margin: 0;
  }
}

.auth-status-card {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  margin-top: 20px;
}

.auth-status-done {
  background-color: #f0fff4;
  border: 1px solid #b7eb8f;
}

.auth-status-text {
  margin-left: 12px;
}

.auth-status-title {
  font-size: 16px;
  font-weight: 600;
  color: #07c160;
}

.auth-status-sub {
  font-size: 13px;
  color: #52c41a;
  margin-top: 4px;
}

.auth-tips {
  margin-top: 20px;
}

.auth-notice {
  text-align: center;
  color: #999;
  font-size: 12px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
</style>
